import { createSelector } from 'reselect';
import { RootState } from 'lib/centralStore';

const _self = (state: RootState) => state.liveFavouriteAvvenimento;

export const selectLiveAvvenimentoList = () =>
  createSelector([_self], (liveFavouriteAvvenimento) => liveFavouriteAvvenimento?.liveAvvenimentoList ?? []);
